import {useNavigate, useParams} from "react-router-dom";
import {useCallback, useEffect, useState} from "react";
import {getDetailById} from "./Integracion";
import DetallesComponent from "./components/DetallesComponent";

const DetalleCotizacion = () => {
    const {id} = useParams();
    const navigate = useNavigate();

    const [cotizacion, setCotizacion] = useState(null);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState(null);

    const cargarCotizacion = useCallback(async () => {
        try {
            setCargando(true);
            setError(null);
            const cot = await getDetailById(id);
            setCotizacion(cot.data);
        } catch (err) {
            setError(err.message || "Ocurrió un error al cargar la información.");
        } finally {
            setCargando(false);
        }
    }, [id]);

    useEffect(() => {
        cargarCotizacion();
    }, [cargarCotizacion]);

    /**
     * Navega al panel de generación de trazo.
     * @param {string} tipo - "E" (entrada) o "S" (salida)
     */
    const handleGenerarTrazo = useCallback((tipo) => {
        const tipoLabel = tipo === "E" ? "entrada" : "salida";
        navigate(`/cotizaciones/empresariales/${id}/trazos/nuevo/${tipoLabel}`);
    }, [id, navigate]);

    /**
     * Navega al panel de edición de los trazos.
     * @param {string} tipo    - "E" (entrada) o "S" (salida)
     * @param {number} trazoId - ID del trazo base a editar
     */
    const handleEditarAllTrazos = useCallback((tipo, trazoId) => {
        const tipoLabel = tipo === "E" ? "entrada" : "salida";
        navigate(`/cotizaciones/empresariales/${id}/trazos/editar/${trazoId}/${tipoLabel}`);
    }, [id, navigate]);

    /**
     * Navega al panel de edición de trazo.
     * @param {string} tipo    - "E" (entrada) o "S" (salida)
     * @param {number} trazoId - ID del trazo a editar
     */
    const handleEditarTrazo = useCallback((tipo, trazoId) => {
        const tipoLabel = tipo === "E" ? "entrada" : "salida";
        navigate(`/cotizaciones/empresariales/${id}/trazo/editar/${trazoId}/${tipoLabel}`);
    }, [id, navigate]);


    /**
     * Navega de regreso a la vista principal de la cotización
     */
    const handleVolverACotizacion = useCallback(() => {
        navigate(`/cotizaciones/empresariales/${id}`);
    }, [id, navigate]);

    return (
        <DetallesComponent
            cotizacion={cotizacion}
            setCotizacion={setCotizacion}
            cargando={cargando}
            error={error}
            onRegresar={() => navigate("/cotizaciones/empresariales")}
            onEditar={(cotizId) => navigate(`/cotizaciones/empresariales/editar/${cotizId}`)}
            onEditarMod={(cotizId) => navigate(`/cotizaciones/empresariales/modificacion/editar/${cotizId}`)}
            onGenerarTrazo={handleGenerarTrazo}
            handleEditarAllTrazos={handleEditarAllTrazos}
            onEditarTrazo={handleEditarTrazo}
        />
    );
};

export default DetalleCotizacion;
